import { Tooltip, withStyles } from '@material-ui/core';
import React from 'react';

const TooltipCustom = ({ children, title, placement, variant, arrow, size = 'medium' }) => {
  // Helper function to get padding based on size
  const getPadding = (size) => {
    switch (size) {
      case 'small':
        return '6px 10px';
      case 'large':
        return '15px 21px';
      case 'medium':
      default:
        return '12px 16px';
    }
  };

  const CustomTooltip = withStyles({
    tooltip: {
      color: '#2b2b2b',
      backgroundColor: '#FFF3C9',
      padding: size === 'large' ? '15px 21px' : getPadding(size),
      fontSize: '14px',
      borderRadius: '4px',
      border: '1px solid #DBD5CE',
    },
    arrow: {
      color: '#FFF3C9',
    },
  })(Tooltip);

  const ToolTipCustomV2 = withStyles({
    tooltip: {
      width: 'auto',
      height: 'auto',
      padding: getPadding(size),
      fontFamily: "'Titilium Regular', sans-serif",
      fontSize: '15px',
      color: '#36393B',
      backgroundColor: '#FFF3C9',
      border: '1px solid #EBDFB6',
      boxShadow: '-2px 2px 11px 1px rgba(0,0,0,0.1)',
      marginBottom: '35px',
    },
    arrow: {
      '&:before': {
        border: '1px solid #EBDFB6',
      },
      color: '#FFF3C9',
    },
  })(Tooltip);

  const TooltipDark = withStyles({
    tooltip: {
      width: 'auto',
      height: 'auto',
      fontWeight: 700,
      padding: getPadding(size),
      fontFamily: "'Lato Bold', sans-serif",
      fontSize: '14px',
      color: '#FFFFFF',
      backgroundColor: '#4E4E4E',
      borderRadius: '8px',
    },
    arrow: {
      '&:after': {
        border: '1px solid #4E4E4E',
      },
      color: '#4E4E4E',
    },
  })(Tooltip);

  function renderChildren() {
    return <div className="tooltip">{children}</div>;
  }

  return (
    <>
      {variant === 'secondary' && (
        <CustomTooltip title={title} placement={placement}>
          {renderChildren()}
        </CustomTooltip>
      )}
      {variant === 'custom' && (
        <ToolTipCustomV2 title={title} placement={placement} arrow={arrow}>
          {renderChildren()}
        </ToolTipCustomV2>
      )}
      {variant === 'dark' && (
        <TooltipDark title={title} placement={placement} arrow={arrow}>
          {renderChildren()}
        </TooltipDark>
      )}
      {variant === 'default' && (
        <Tooltip title={title} placement={placement}>
          {renderChildren()}
        </Tooltip>
      )}
    </>
  );
};

export default TooltipCustom;
